// extracted by mini-css-extract-plugin
module.exports = {"timeline":"Timeline_timeline__1Qn2O","spinner":"Timeline_spinner__1uo_W","svg":"Timeline_svg__2Kx1o"};